import React, { useEffect, useRef, useState } from "react";
import DashboardLayout from "../../DashboardLayout";
import { Button, Form, Table } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { fetchAdsCountByCountries } from "../../../services/axios/apiManager";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import BSPagination from "../../../Components/pagination";
import LoadingSpinner from "../../../Components/spinner";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function AdRevenueByCountryRegion() {
  const tableRef = useRef(null);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [pagination, setPagination] = useState({});
  const [fetching, setFetching] = useState(true);

  const getAdsCountByCountries = async (
    page = pagination?.currentPage || 1,
    pageSize = pagination?.pageSize || 10
  ) => {
    setFetching(true);
    const res = await fetchAdsCountByCountries(page, pageSize);
    if (res?.data?.success && res?.data?.data) {
      setTableData(res.data.data);
      setPagination(res?.data?.metadata);
      if (selectedCountry?.length) {
        const temp = res.data.data?.filter(
          (f) => f.country_id == selectedCountry
        );
        setFilteredData(temp);
      } else {
        setFilteredData(res.data.data);
      }
    }
    setFetching(false);
  };

  const handleCountryChange = (e) => {
    setSelectedCountry(e.target.value);
    if (e?.target?.value?.length) {
      const temp = tableData.filter((f) => f.country_id == e.target.value);
      setFilteredData(temp);
    } else {
      setFilteredData(tableData);
    }
  };

  const handleReset = () => {
    setSelectedCountry("");
    setFilteredData(tableData);
  };

  const handlePageChange = async (page) => {
    handleReset();
    await getAdsCountByCountries(page, pagination.pageSize || 10);
  };

  const chartData = {
    labels: filteredData.map((item) => item.country_name),
    datasets: [
      {
        label: "Ad Views",
        data: filteredData.map((item) => item?.total_ads_watched || 0),
        backgroundColor: "rgba(255, 99, 132, 0.6)",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        labels: { color: "#ffffff" },
      },
    },
    scales: {
      x: { ticks: { color: "#ffffff" } },
      y: {
        beginAtZero: true,
        ticks: { color: "#ffffff" },
      },
    },
  };

  useEffect(() => {
    getAdsCountByCountries();
  }, []);

  useEffect(() => {
    const $table = $(tableRef.current);
    const rows = filteredData.map((item) => {
      return [item.country_name, item.total_ads_watched];
    });

    const config = {
      data: rows,
      columns: [{ title: "Country" }, { title: "Ad Views" }],
      destroy: true,
      responsive: true,
      paging: false,
      searching: false,
    };

    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $table.DataTable().clear().rows.add(rows).draw();
    } else {
      $table.DataTable(config);
    }
    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $table.DataTable().destroy();
      }
    };
  }, [filteredData]);

  return (
    <DashboardLayout>
      {/* Filter Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Filter by Country/Region</h5>
          <div className="row align-items-center">
            <div className="col-md-3">
              <Form.Select
                className="bg-dark text-light border-light"
                value={selectedCountry}
                onChange={handleCountryChange}
              >
                <option value="">All countries</option>
                {tableData?.map((country) => (
                  <option key={country.country_id} value={country.country_id}>
                    {country.country_name}
                  </option>
                ))}
              </Form.Select>
            </div>
            <div className="col-md-2">
              {fetching ? (
                <LoadingSpinner size={"small"} />
              ) : (
                <Button variant="success" onClick={handleReset}>
                  Reset
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Table Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Ad Revenue by Country</h5>
          <p className="card-text">Breakdown of ad revenue by country.</p>
          <div className="table-responsive">
            <table
              ref={tableRef}
              className="table table-dark table-striped table-hover w-100"
            />
            {filteredData.length === 0 && (
              <p className="text-muted mt-3">No data available.</p>
            )}
          </div>
          <div className="constainer-fluid">
            <div className="d-flex justify-content-end">
              <div className="mx-4 py-2">
                <span className="text-light">{`Rows/Page ${pagination.pageSize || 0}, Total records ${pagination?.totalRecords || 0}`}</span>
              </div>
              <BSPagination
                currentPage={pagination?.currentPage}
                totalPages={pagination?.totalPages}
                onPageChange={handlePageChange}
                siblingCount={2}
                showFirstLast={true}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Chart Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h6 className="mb-3">Revenue Chart</h6>
          <Bar data={chartData} options={chartOptions} />
        </div>
      </div>
    </DashboardLayout>
  );
}

export default AdRevenueByCountryRegion;
